(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  class HeroBannerSlider extends HTMLElement {
    #track;
    #slides;
    #prevButton;
    #nextButton;
    #playPauseButton;
    #dots;
    #activeIndex = 0;
    #autoplayTimer = null;
    #autoplay = false;
    #autoplaySpeed = 5000;
    #isPlaying = false;
    #abortController = null;

    connectedCallback() {
      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      this.#track = this.querySelector('.hero-slider__track');
      this.#slides = Array.from(this.querySelectorAll('.hero-slider__slide'));
      this.#prevButton = this.querySelector('.hero-slider__arrow--prev');
      this.#nextButton = this.querySelector('.hero-slider__arrow--next');
      this.#playPauseButton = this.querySelector('.hero-slider__play-pause');
      this.#dots = Array.from(this.querySelectorAll('.hero-slider__dot'));

      if (!this.#track || this.#slides.length === 0) return;

      this.#autoplay = this.dataset.autoplay === 'true';
      this.#autoplaySpeed = Number(this.dataset.autoplaySpeed) || 5000;

      this.#prevButton?.addEventListener('click', () => this.#goTo(this.#activeIndex - 1), { signal });
      this.#nextButton?.addEventListener('click', () => this.#goTo(this.#activeIndex + 1), { signal });

      for (const [index, dot] of this.#dots.entries()) {
        dot.addEventListener('click', () => this.#goTo(index), { signal });
      }

      this.#playPauseButton?.addEventListener('click', () => this.#toggleAutoplay(), { signal });

      this.addEventListener('keydown', (event) => this.#handleKeydown(event), { signal });
      this.addEventListener('pointerenter', () => this.#stopAutoplay(), { signal });
      this.addEventListener('pointerleave', () => this.#resumeAutoplayIfEnabled(), { signal });
      this.addEventListener('focusin', () => this.#stopAutoplay(), { signal });
      this.addEventListener('focusout', () => this.#resumeAutoplayIfEnabled(), { signal });
      document.addEventListener('visibilitychange', () => this.#handleVisibilityChange(), { signal });

      this.#setupSwipe(signal);

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.#autoplay && this.#slides.length > 1 && !reducedMotion) {
        this.#startAutoplay();
      }

      this.#render();
    }

    disconnectedCallback() {
      this.#abortController?.abort();
      this.#stopAutoplay();
    }

    #goTo(index) {
      const total = this.#slides.length;
      this.#activeIndex = (index + total) % total;
      this.#render();
    }

    #render() {
      this.style.setProperty('--hero-active-index', String(this.#activeIndex));

      for (const [index, slide] of this.#slides.entries()) {
        const isActive = index === this.#activeIndex;
        slide.toggleAttribute('aria-hidden', !isActive);
        if (isActive) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }

        const link = slide.querySelector('.hero-slider__button');
        if (link) link.tabIndex = isActive ? 0 : -1;
      }

      for (const [index, dot] of this.#dots.entries()) {
        const isActive = index === this.#activeIndex;
        dot.classList.toggle('hero-slider__dot--active', isActive);
        dot.setAttribute('aria-selected', String(isActive));
      }
    }

    #handleKeydown(event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.#goTo(this.#activeIndex - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.#goTo(this.#activeIndex + 1);
      }
    }

    #startAutoplay() {
      if (this.#autoplayTimer) return;
      this.#isPlaying = true;
      this.#updatePlayPauseUI();
      this.#autoplayTimer = setInterval(() => {
        this.#goTo(this.#activeIndex + 1);
      }, this.#autoplaySpeed);
    }

    #stopAutoplay() {
      if (this.#autoplayTimer) {
        clearInterval(this.#autoplayTimer);
        this.#autoplayTimer = null;
      }
      this.#isPlaying = false;
      this.#updatePlayPauseUI();
    }

    #resumeAutoplayIfEnabled() {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.#autoplay && !this.#userPaused && this.#slides.length > 1 && !reducedMotion) {
        this.#startAutoplay();
      }
    }

    #toggleAutoplay() {
      if (this.#isPlaying) {
        this.#userPaused = true;
        this.#stopAutoplay();
      } else {
        this.#userPaused = false;
        this.#startAutoplay();
      }
    }

    #userPaused = false;

    #updatePlayPauseUI() {
      if (!this.#playPauseButton) return;
      this.#playPauseButton.setAttribute('aria-pressed', String(this.#isPlaying));
      this.#playPauseButton.setAttribute('aria-label', this.#isPlaying ? 'Pausar presentación' : 'Reanudar presentación');
      const pauseIcon = this.#playPauseButton.querySelector('.hero-slider__icon-pause');
      const playIcon = this.#playPauseButton.querySelector('.hero-slider__icon-play');
      if (pauseIcon) pauseIcon.hidden = !this.#isPlaying;
      if (playIcon) playIcon.hidden = this.#isPlaying;
    }

    #handleVisibilityChange() {
      if (document.hidden) {
        this.#stopAutoplay();
      } else {
        this.#resumeAutoplayIfEnabled();
      }
    }

    #setupSwipe(signal) {
      let startX = 0;
      let isDragging = false;

      this.#track.addEventListener('pointerdown', (event) => {
        startX = event.clientX;
        isDragging = true;
      }, { signal });

      this.#track.addEventListener('pointerup', (event) => {
        if (!isDragging) return;
        isDragging = false;
        const deltaX = event.clientX - startX;
        const threshold = 40;
        if (deltaX > threshold) {
          this.#goTo(this.#activeIndex - 1);
        } else if (deltaX < -threshold) {
          this.#goTo(this.#activeIndex + 1);
        }
      }, { signal });
    }
  }

  customElements.define('hero-banner-slider', HeroBannerSlider);

  } catch(e) { console.error(e); }
})();
})();
